export const handleError = (axiosError) => {
  console.log('Raw Error', axiosError)
  const errors = ['Something went wrong']

  if (axiosError?.response?.status === 403) {
    return (window.location.href = '/forbidden')
  }

  if (axiosError?.response?.data) {
    if (axiosError?.response?.data?.errors) {
      return Object.values(axiosError?.response?.data?.errors)[0]
    }
    return axiosError?.response?.data?.detail ? [axiosError.response.data.detail] : errors
  }

  return errors
}
